import React from 'react';
import { Link } from 'react-router-dom';
import SettingsMembers from '../SettingsMembers';

const SettingsTab: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Workspace Settings Card */}
      <div className="rounded-xl bg-white p-6 shadow-sm ring-1 ring-gray-100">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <h2 className="text-lg font-semibold text-gray-900">Workspace Settings</h2>
          <Link
            to="/help?article=crm-settings-team"
            className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-semibold text-gray-600 shadow-sm transition hover:bg-gray-50"
          >
            ❓ Settings help
          </Link>
        </div>
        <p className="mb-6 text-sm text-gray-600">
          Manage team members, permissions, and workspace configuration.
        </p>
        <SettingsMembers />
      </div>
    </div>
  );
};

export default SettingsTab;
